import React, {Component} from "react";
import Form from "../../../shared/components/Form";
import TutorialPopover from "../../../shared/components/TutorialPopover";
import {Button, Col, FormGroup, FormText, Input} from "reactstrap";
import * as moment from "moment";

class CampaignProgramForm extends Component {
    constructor(props){
        super(props);

        this.state = {
            validationMessages:{},
            isShowingPopover:false
        };
    }

    componentWillMount(){
        if(this.props.open){
            window.setTimeout(() => this.setState({isShowingPopover:true}),500);
        }
        this.setState({programId: this.props.activeCampaign.programId, activeProgram: this.getProgramBy(this.props.activeCampaign.programId)})
        // this.validateDates(this.props.activeCampaign.programId)
    }

    componentWillReceiveProps(nextProps){
        if(!this.props.open && nextProps.open){
            window.setTimeout(() => this.setState({isShowingPopover:true}),500);
        }

        if(this.props.open && !nextProps.open){
            this.setState({isShowingPopover:false});
        }
    }

    getProgramTitle(program) {
        return program ? `${program.name} (${moment.utc(program.startDate).format('MM/DD/YYYY')}-${moment.utc(program.endDate).format('MM/DD/YYYY')}) - $${program.cardAmount}` : ''
    }

    getProgramBy(programId){
        return programId && programId.trim().length > 0 ? this.props.programs.filter((c) => c.id === programId).shift() : null
    }

    handleProgramChange(programId){
        this.setState({programId: programId, activeProgram: this.getProgramBy(programId)});
    }

    handleSubmit(data){
        // this.validateDates(data.programId)
        this.props.onSubmit({...data, activeProgram: this.state.activeProgram});
    }

    render(){
        const { programId, validationMessages} = this.state;
        const {activeCampaign, programs, isValidRange} = this.props
        return (
            <Form
                includeEmpty
                onSubmit={(data) => this.handleSubmit(data)}
            >
                <TutorialPopover
                    open={this.state.isShowingPopover && this.props.isShowingTutorial}
                    target='CampaignProgramInput'
                    onCloseClick={() => this.setState({isShowingPopover:false})}
                    title='Program Name'
                >
                    <p>
                        The program the experience belongs to
                    </p>
                </TutorialPopover>
                <FormGroup>
                    <Input id='CampaignProgramInput'
                        type='select'
                           name='programId'
                           defaultValue={activeCampaign.programId}
                           onChange={(e) => this.handleProgramChange(e.target.value)}>
                        <option key='' value=''>{programs.length === 0 ? 'No Programs Available' : 'Not Selected'}</option>
                        {programs.map((c) => (
                            <option key={c.id} value={c.id}>
                                {this.getProgramTitle(c)}
                            </option>
                        ))}
                    </Input>
                    {!isValidRange && (
                        <FormText className='DangerFeedback'>Experience launch/end dates should be in range of program start/end dates</FormText>
                    )}
                </FormGroup>
                <Button size='sm' color='primary' disabled={programs.length === 0}>
                    &nbsp;&nbsp;Save&nbsp;&nbsp;
                </Button>
            </Form>
        )
    }
}

CampaignProgramForm.defaultProps = {
    isShowingTutorial:true,
    priority: 9
};

export default CampaignProgramForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignProgramForm.js